import React, { type PropsWithChildren } from 'react'

import BridgeProvider from './BridgeProvider'
import HelperProvider from './HelperProvider'
import I18nLocaleProvider from './I18nLocaleProvider'
import WalletProvider from './WalletProvider'

const RootProvider: React.FC<PropsWithChildren> = ({ children }) => {
  return (
    <I18nLocaleProvider>
      <WalletProvider>
        <BridgeProvider>
          <HelperProvider>{children}</HelperProvider>
        </BridgeProvider>
      </WalletProvider>
    </I18nLocaleProvider>
  )
}

export default RootProvider
